export function changeDaysWeek(value) {
  return {
    type: '@vehicleregistration/VEHICLE_DAYSWEEK',
    payload: { value },
  };
}

export function changeBlockDates(value) {
  return {
    type: '@vehicleregistration/VEHICLE_BLOCKDATES',
    payload: { value },
  };
}

export function changeCounties(value) {
  return {
    type: '@vehicleregistration/VEHICLE_COUNTIES',
    payload: { value },
  };
}

export function changeQuotas(value) {
  return {
    type: '@vehicleregistration/VEHICLE_QUOTAS',
    payload: { value },
  };
}

export function changeCountiesProduts(value) {
  return {
    type: '@vehicleregistration/MUNICIPIOPRODUTOS',
    payload: { value },
  };
}

export function resetValues() {
  return {
    type: '@vehicleregistration/VEHICLE_RESETVALUES',
  };
}
